export default __webpack_public_path__ + "static/media/linguisticRanger.dccb8cd0.svg";